import * as React from 'react';
import antd, {
  Form,
  Icon,
  Input,
  Button,
  Checkbox,
  Row,
  Col,
  Select,
  notification,
  message,
  Popover,
} from 'antd';
import { FormComponentProps } from 'antd/lib/form';
import { IndividualRegistration } from 'Core/Api/UserManagement/Api';
import { RegistrationWizardHandler } from './RegistrationWizardHandler';
import { RouteComponentProps, withRouter, Route } from 'react-router';
// import ReactInputMask from 'react-input-mask';
import MaskedInput from 'components/Forms/MaskedInput';
import FormControl from 'components/Forms/FormControl';
import { NavLink, Link } from 'react-router-dom';
import ValidationUtility from 'Core/ValidationUtility';
import { LeftAlignUl, ColLayout, ReCaptchaColLayout } from './RegistrationWizardForm.Styled';
import FormUtility from 'Core/FormUtility';
import TermsAndConditionsView from 'components/Information/TermsAndConditionsView';
import TermsAndConditionLink from 'components/Forms/TermsAndConditionLink';
import NotificationUtility from 'Core/NotificationUtility';
import ReCaptcha from '../../../ReCaptcha/ReCaptcha';
import { SubmitButton } from 'components/SubmitButton';

export interface Props extends FormComponentProps, RouteComponentProps {
  children?: React.ReactNode;
}

export interface State {
  confirmTrue: boolean;
}

class BaseRegistrationWizardForm extends React.Component<Props, State> {
  individualRegistrationHandler: RegistrationWizardHandler;
  recaptchaInstance;

  constructor(props: Props) {
    super(props);
    this.individualRegistrationHandler = new RegistrationWizardHandler(props);
    this.onFormSubmit = this.onFormSubmit.bind(this);
    this.recaptchaInstance = React.createRef();

    this.state = {
      confirmTrue: false,
    };
  }

  componentDidMount() {
    this.setState({});
  }

  onFormSubmit(event: React.FormEvent) {
    event.preventDefault();

    this.props.form.validateFieldsAndScroll((error, values: IndividualRegistration) => {
      if (!error) {
        this.individualRegistrationHandler
          .RegisterIndividualUser(values)
          .then(() => {
            NotificationUtility.success(
              'Registration Success',
              'Registration was successful, email confirmation token sent to email.',
              1000,
              true
            );

            //route to email confirmation after successful registration submission
            this.props.history.push('/emailconfirmation');
          })
          .catch(x => {
            NotificationUtility.error('Issue With Registration', x.message || x, 1000, true);
          })
          .finally(() => {
            //reset recaptcha
            try {
              this.resetRecaptcha();
            } catch (ex) { }
          });
      }
      // console.log(typeof (values.primaryUser))//seen as an object
    });
  }

  resetRecaptcha = () => {
    if (this.recaptchaInstance.current) {
      this.recaptchaInstance.current.reset();
      this.props.form.resetFields(['reCaptchaToken']);
    }
  };

  //validate confirm password
  compareToFirstPassword = (rule, value, callback) => {
    const { form } = this.props;
    if (value && value !== form.getFieldValue('primaryUser.password')) {
      callback('Two passwords that you enter is inconsistent!');
    } else {
      callback();
    }
  };

  renderPasswordErrorMessage() {
    return (
      <LeftAlignUl>
        <li>Password must contain at least one number</li>
        <li>One lowercase and one uppercase letter</li>
        <li>At least six characters that are letters, numbers or the underscore</li>
      </LeftAlignUl>


    );
  }

  render() {
    const { getFieldDecorator, ...form } = this.props.form;

    return (
      <Row style={{ border: "solid lightgrey 2px", borderRadius: "15px", padding: "15px 20px", marginTop: "5px" }}>
        <Col span={24}>
          <Form onSubmit={this.onFormSubmit} layout="vertical">
            <Row type="flex" align="top" gutter={10}>
              {/* First Page */}
              <Col {...ColLayout}>
                <FormControl
                  getFieldDecorator={getFieldDecorator}
                  rules={[
                    ...ValidationUtility.getRequired('Please enter your TRN'),
                    ...ValidationUtility.getPattern(
                      /[0-9]{3}-[0-9]{3}-[0-9]{3}/,
                      'Please enter valid TRN'
                    ),
                  ]}
                  label="TRN"
                  name="trn">
                  <MaskedInput
                    prefix={<Icon type="user" style={{ color: 'rgba(0,0,0,.25)' }} />}
                    mask="999-999-999"
                    alwaysShowMask={true}
                    className="Sumperess"
                    placeholder="TRN"
                    tabIndex={1}
                  />
                </FormControl>

                <FormControl
                  getFieldDecorator={getFieldDecorator}
                  rules={[...ValidationUtility.getRequired('Please enter your First Name')]}
                  name="primaryUser.firstName"
                  label="First Name">
                  <Input
                    tabIndex={3}
                    prefix={<Icon type="user" style={{ color: 'rgba(0,0,0,.25)' }} />}
                    placeholder="First Name"
                  />
                </FormControl>

                <FormControl
                  getFieldDecorator={getFieldDecorator}
                  rules={[...ValidationUtility.getRequired('Please enter address 1')]}
                  name="addressLine1"
                  label="Address 1">
                  <Input
                    tabIndex={5}
                    prefix={<Icon type="pushpin" style={{ color: 'rgba(0,0,0,.25)' }} />}
                    placeholder="Address 1"
                  />
                </FormControl>

                <Row justify="space-around" align="middle" gutter={8}>
                  <Col span={12}>
                    <FormControl
                      getFieldDecorator={getFieldDecorator}
                      rules={[...ValidationUtility.getRequired('Please select a Parish')]}
                      name="parish"
                      label="Parish">
                      {FormUtility.parishSelector()}
                    </FormControl>
                  </Col>

                  <Col span={12}>
                    <FormControl
                      getFieldDecorator={getFieldDecorator}
                      name="postalCode"
                      label="Postal Code">
                      <Input
                        tabIndex={8}
                        prefix={<Icon type="mail" style={{ color: 'rgba(0,0,0,.25)' }} />}
                        placeholder="Postal Code"
                      />
                    </FormControl>
                  </Col>

                </Row>
                <FormControl
                  getFieldDecorator={getFieldDecorator}
                  rules={[
                    ...ValidationUtility.getRequired('Please enter your password'),
                    ...ValidationUtility.validateOtherFields(this.props.form, [
                      'primaryUser.confirmPassword',
                    ]),
                    ...ValidationUtility.getPattern(
                      /(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}/,
                      this.renderPasswordErrorMessage()
                    ),
                  ]}
                  name="primaryUser.password"
                  label="Password">
                  <Input.Password tabIndex={10}
                    prefix={
                      <Icon type="lock" theme="filled" style={{ color: 'rgba(0,0,0,.25)' }} />
                    }
                    placeholder="Password"
                  />
                </FormControl>



              </Col>

              <Col {...ColLayout}>

                <FormControl
                  getFieldDecorator={getFieldDecorator}
                  rules={[
                    ...ValidationUtility.getRequired('Please enter your email'),
                    ...ValidationUtility.getType('email', 'This input is not a valid email'),
                  ]}
                  name="primaryUser.email"
                  label="Email">
                  <Input
                    tabIndex={2}
                    prefix={<Icon type="mail" style={{ color: 'rgba(0,0,0,.25)' }} />}
                    placeholder="Email"
                  />
                </FormControl>

                <FormControl
                  getFieldDecorator={getFieldDecorator}
                  rules={[...ValidationUtility.getRequired('Please enter your Last Name')]}
                  name="primaryUser.lastName"
                  label="Last Name">
                  <Input
                    tabIndex={4}
                    prefix={<Icon type="user" style={{ color: 'rgba(0,0,0,.25)' }} />}
                    placeholder="LastName"
                  />
                </FormControl>

                <FormControl
                  getFieldDecorator={getFieldDecorator}
                  name="addressLine2"
                  label="Address 2">
                  <Input
                    tabIndex={6}
                    prefix={<Icon type="pushpin" style={{ color: 'rgba(0,0,0,.25)' }} />}
                    placeholder="Address 2"
                  />
                </FormControl>

                {/* Second Page */}
                <FormControl
                  getFieldDecorator={getFieldDecorator}
                  rules={[
                    ...ValidationUtility.getRequired('Please enter your telephone number'),
                    ...ValidationUtility.getPattern(
                      /[0-9]{3}-[0-9]{3}-[0-9]{4}/,
                      'Please enter valid mobile number'
                    ),
                  ]}
                  label="Mobile Number"
                  name="primaryUser.mobileNumber">
                  <MaskedInput
                    tabIndex={9}
                    prefix={<Icon type="phone" style={{ color: 'rgba(0,0,0,.25)' }} />}
                    mask="999-999-9999"
                    alwaysShowMask={true}
                    className="Sumperess"
                    placeholder="Mobile Number"
                  />
                </FormControl>

                <FormControl
                  getFieldDecorator={getFieldDecorator}
                  rules={[
                    ...ValidationUtility.getRequired('Please confirm your password'),
                    ...ValidationUtility.getCompareField(
                      this.props.form,
                      'primaryUser.password',
                      'Passwords do not match'
                    ),
                  ]}
                  name="primaryUser.confirmPassword"
                  label="Confirm Password">
                  <Input.Password
                    tabIndex={11}
                    prefix={
                      <Icon type="lock" theme="filled" style={{ color: 'rgba(0,0,0,.25)' }} />
                    }
                    placeholder="Confirm Password"
                  />
                </FormControl>
              </Col>
            </Row>

            {/* ReCAPTcha */}
            <Row>
              <Col {...ReCaptchaColLayout}>
                <FormControl
                  getFieldDecorator={getFieldDecorator}
                  rules={[...ValidationUtility.getRequired('Please check the checkbox')]}
                  name="recaptcha"
                  valuePropName="checked">
                  <ReCaptcha reCaptchaID="registrationReCaptcha" ref={this.recaptchaInstance} />
                </FormControl>
              </Col>
            </Row>

            <Row>
              <Col>
                <Form.Item>
                  {getFieldDecorator('termsCon', {
                    rules: [
                      ...ValidationUtility.getCheckBoxChecked(
                        'Please Agree to the Terms and Conditions!'
                      ),
                    ],
                    valuePropName: 'checked',
                    initialValue: false,
                  })(<Checkbox> I Accept</Checkbox>)}
                  <TermsAndConditionLink />
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <SubmitButton type="primary" htmlType="submit" style={{ textAlign: "center" }}>Complete Sign Up</SubmitButton>
              <p>
                If you already have an account&nbsp;
                <NavLink to="/login" className="login-form-forgot">
                  Login now!
                </NavLink>
              </p>
            </Row>
          </Form>
        </Col>
      </Row>
    );
  }
}

const RegistrationWizardFormWithoutRoute = Form.create<Props>({
  name: 'RegistrationWizard',
})(BaseRegistrationWizardForm);

const RegistrationWizardForm = withRouter(RegistrationWizardFormWithoutRoute);

export default RegistrationWizardForm;
